import { DATETIME_FORMAT } from "@/common/constant";
import trans18next from "@/i18n";
import moment from "moment";
import { CONTRACT_HISTORY_TYPE } from "./contract";
import User from "./user";

export interface IContractHistory {
  id: string;
  type: CONTRACT_HISTORY_TYPE;
  target: string;
  old_value: string;
  new_value: string;
  created_at: string;
  by: User;
}


export class ContractHistoryDTO implements IContractHistory {
  id: string;
  type: CONTRACT_HISTORY_TYPE;
  target: string;
  old_value: string;
  new_value: string;
  created_at: string;
  by: User;
}

export default class ContractHistory extends ContractHistoryDTO {
  historyAt;
  content;
  constructor(dto?: ContractHistoryDTO) {
    super();
    Object.assign(this, dto);
    this.historyAt = moment(dto.created_at).format(DATETIME_FORMAT);
    this.content = this.generateContent();
  }

  protected generateContent() {
    let content = '';
    switch (this.type) {
    case CONTRACT_HISTORY_TYPE.REGISTRATION:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.REGISTRATION, {
        createdBy: this.by.username,
        contractName: this.new_value
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.CHANGE_DETAIL:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.CHANGE_DETAIL, {
        createdBy: this.by.username,
        itemName: trans18next.t("contractFieldNames." + this.target),
        oldValue: this.old_value,
        newValue: this.new_value,
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.APPLY_MOVING_OUT:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.APPLY_MOVING_OUT, {
        createdBy: this.by.username,
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.ADD_ATTACHMENT:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.ADD_ATTACHMENT, {
        createdBy: this.by.username,
        filename: this.new_value,
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.REMOVE_ATTACHMENT:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.REMOVE_ATTACHMENT, {
        createdBy: this.by.username,
        filename: this.new_value,
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.CHANGE_IMAGE:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.CHANGE_IMAGE, {
        createdBy: this.by.username,
      }).toString();
      break;
    case CONTRACT_HISTORY_TYPE.CHANGE_FILE_NAME:
      content = trans18next.t("contractHistoriesFromat." + CONTRACT_HISTORY_TYPE.CHANGE_FILE_NAME, {
        createdBy: this.by.username,
      }).toString();
      break;
    default:
      content = ''
    }
    return content;
  }
}
